// extracted by mini-css-extract-plugin
export default {"rdc_submenu__content":"Submenu_rdc_submenu__content__ey2Tv"};